module.exports = ":host .footer {\n  margin-top: 15px;\n  bottom: 0;\n  width: 100%;\n  height: 60px;\n  line-height: 60px; }\n"